export default __webpack_public_path__ + "static/media/ghiradelliCropped.6100b49d.jpg";